import React from 'react'
import { Form } from 'react-bootstrap'
import UploadFile from './UploadFile'

const ProductDocuments = ({ allTypesOfDocuments, uploadDocs, reload }) => {
  return (
    <div className='documents-upload-container'>
      <div className='upload-info-text'>
        Solo se admiten documentos de tipo .pdf
      </div>

      <div className='documents-upload-grid'>
        {allTypesOfDocuments
          ? allTypesOfDocuments.map((typeDoc) => (
              <div
                className='document-upload-field'
                key={typeDoc.id_TipoDocumentos}
              >
                <Form.Group size='lg'>
                  <Form.Label className='form__labels'>
                    {typeDoc.nombre}
                  </Form.Label>
                  <UploadFile
                    uploadFile={uploadDocs}
                    typeDoc={typeDoc.id_TipoDocumentos}
                    multiple={'multiple'}
                    reload={reload}
                    typeUpload={'.pdf'}
                  />
                </Form.Group>
              </div>
            ))
          : null}
      </div>
    </div>
  )
}

export default ProductDocuments
